import React from "react";
import { Link } from "react-router-dom";
import { Container, PageHeader } from "@/components/common";
import { Users, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div>
      <PageHeader eyebrow="About us" title="Lawley Village Line Dance Club"
        subtitle="A friendly, welcoming line dance club based in Telford & Shropshire. Everyone's welcome — no partner needed, just bring a smile and comfy shoes." />
      <Container className="py-10">
        <div className="prose max-w-2xl">
          <p className="text-lg leading-relaxed text-[#5C4A42]">
            We run weekly classes for all abilities, from absolute beginners taking their very first steps to
            improvers looking to polish their favourite routines. Our friendly instructors break every dance
            down slowly, and there's always a warm welcome waiting for newcomers.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-[#5C4A42]">
            More about our story is coming soon — in the meantime, meet the team behind the club.
          </p>
        </div>
        <Link to="/instructors" data-testid="about-instructors-link"
          className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-border bg-card p-5 hover:border-[#C85A32]">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FBEBE4] text-[#B04B26]"><Users size={24} /></span>
          <span>
            <span className="block font-display text-lg font-bold text-[#2D1E18]">Meet our instructors</span>
            <span className="block text-sm text-[#5C4A42]">Get to know the friendly faces who'll teach you.</span>
          </span>
          <ArrowRight size={18} className="ml-2 text-[#6E5B51]" />
        </Link>
      </Container>
    </div>
  );
}
